<template>
  <div
    class="the-tooltip d-flex"
  >
    <slot />
    <el-tooltip
      :effect="theme"
      :content="label"
      :placement="placement"
    >
      <slot name="trigger">
        <sup>?</sup>
      </slot>
    </el-tooltip>
  </div>
</template>

<script>
import Vue from 'vue'

const locations = ['start', '', 'end']
const placements = ['top', 'bottom', 'left', 'right'].reduce((prev, curr) => {
  const result = locations.map(loc => (loc ? `${curr}-${loc}` : curr))
  return [...prev, ...result]
}, [])

export default Vue.extend({
  name: 'TheTooltip',
  props: {
    theme: {
      type: String,
      default: 'dark',
      validator: value => [
        'dark',
        'light',
      ].indexOf(value) !== -1,
    },
    label: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'top-start',
      validator: value => placements.indexOf(value) !== -1,
    },
  },
})
</script>

<style lang="scss" scoped>

.the-tooltip {
  sup {
      background-color: #4BA7A2;
      color: white;
      font-weight: bold;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      display: flex;
      font-size: 10px;
      justify-content: center;
      align-items: center;
  }

}
</style>
